var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVTrackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 156,
    height: 156,
    rx: 9.5,
    fill: "#1773BC",
    stroke: "#E2E2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 103V97.9333L58 93.9333V103H54ZM65 103V87.2667L69 83.2667V103H65ZM76 103V83.2667L80 87.3333V103H76ZM87 103V87.3333L91 83.3333V103H87ZM98 103V76.6L102 72.6V103H98ZM54 87.2667V81.6L72.6667 63.0667L83.3333 73.7333L102 55V60.6667L83.3333 79.4L72.6667 68.7333L54 87.2667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVTrackIcon);
export default __webpack_public_path__ + "static/media/vTrackIcon.5c1bb35a98faeac8c587547bacd1355f.svg";
export { ForwardRef as ReactComponent };